import DatabaseService from 'services/DatabaseService.js';
import {SET_CATEGORIES, 
        ADD_CATEGORY,
        ADD_CATEGORIES} from 'actions/types';
import {addAlert} from 'actions/alertModals.js';
import {getCategory, 
        getCategories, 
        isListLoaded}  from 'reducers/categories.js'; import {getCategoryWithNotifications} from 'reducers';

//Action Creators
export const setCategories = (categories) => {
    return { type:SET_CATEGORIES, categories:categories };
}

export const addCategory = (category) => {
    return { type:ADD_CATEGORY, category:category };
}

export const addCategories = (categories) => {
    return { type:ADD_CATEGORIES, categories:categories };
}



//Thunks
export const fetchCategories = (force) => (dispatch, getState) => {
    if(!force) {
        var state = getState();
        if(isListLoaded(state.categories)) {
            return Promise.resolve(getCategories(state.categories));
        }
    }

    return new Promise(function(resolve, reject) {
        DatabaseService.fetchCategories().then(
            function(result){ 
                dispatch(setCategories(result.categories));
                resolve(result.categories);
            },
            function(error){ 
                console.error(error);
                reject(error); 
            });
    });
}


export const toggleSubscription = (id) => (dispatch, getState) => {
    var state = getState();
    var category = getCategory(state.categories, id);
    var userCategory = category.userCategory;
    var enabled = !(userCategory && userCategory.enabled===true);

    var categoryLevel = userCategory && userCategory.categoryLevel;
   
    //immediate update for latency compensation 
    dispatch(addCategory({...category, userCategory:{...userCategory, enabled}}));

    return new Promise(function(resolve, reject) {
        DatabaseService.userCategoryEnable(id, enabled).then(
            function(result){ 
                var userCategory = result.userCategory;
                var [notification] = userCategory.category.notifications;
                //Update local state with real server response
                categoryLevel = (userCategory && userCategory.categoryLevel) || categoryLevel;
                dispatch(addCategory({...category, notifications:[notification], userCategory:{...userCategory, categoryLevel:categoryLevel}}));
                resolve(userCategory);
            },
            function(error){ 
                //Server update failed, revert to old state
                dispatch(addCategory(category));
                if(error.code===1100) {
                    var translator = DatabaseService.getTranslator();
                    var t = translator.t
                    t = t.bind(translator);
                    dispatch(addAlert({size        : 'mini',
                                       title       : t('Error'), 
                                       description : t('categories:::goals_settings_error_goals_limit_reached')}));
                }
                console.error(error);
                reject(error); 
            });
    });
}

export const toggleNotification = (id) => (dispatch, getState) => {
    var state = getState();
    var category = getCategoryWithNotifications(state, id);
    var notification = (category.notifications!=null ? category.notifications[0] : {}) || {};
    var active = !(notification && notification.active===true);
    notification = {...notification, active};
   
    //immediate update for latency compensation 
    dispatch(addCategory({...category, notifications:[notification]}));

    return new Promise(function(resolve, reject) {
        DatabaseService.userCategoryUpdate(id, {notification:{active:active}}).then(
            function(result){ 
                notification = result.notification;
                //Update local state with real server response
                dispatch(addCategory({...category, notifications:[notification]}));
            },
            function(error){ 
                //Server update failed, revert to old state
                dispatch(addCategory(category));
                console.error(error);
                reject(error); 
            });
    });
}

export const updateNotification = (id, notificationUpdate) => (dispatch, getState) => {
/*
    {"categoryId":178,"notification":{"pattern":127,"defaultTime":720,"active":true,"time":720}}
*/

    var state = getState();
    var category = getCategoryWithNotifications(state, id);
    var notification = (category.notifications!=null ? category.notifications[0] : {}) || {};
    notification = {...notification, ...notificationUpdate};
   
    //immediate update for latency compensation 
    dispatch(addCategory({...category, notifications:[notification]}));

    return new Promise(function(resolve, reject) {
        DatabaseService.userCategoryUpdate(id, {notification:notificationUpdate}).then(
            function(result){ 
                notification = result.notification;
                //Update local state with real server response
                dispatch(addCategory({...category, notifications:[notification]}));
            },
            function(error){ 
                //Server update failed, revert to old state
                dispatch(addCategory(category));
                console.error(error);
                reject(error); 
            });
    });
}


export const userCategoryUpdateLevel = (id, level) => (dispatch, getState) => {
    var state = getState();
    var category = getCategory(state.categories, id);
    var userCategory = category.userCategory;
   
    var categoryLevel = userCategory && userCategory.categoryLevel;

    //immediate update for latency compensation 
    dispatch(addCategory({...category, userCategory:{...userCategory, level}}));

    return new Promise(function(resolve, reject) {
        DatabaseService.userCategoryUpdateLevel(id, level).then(
            function(result){ 
                var newCategory = result.category;
                var newUserCategory = newCategory.userCategory;
                //Update local state with real server response
                categoryLevel = (newUserCategory && newUserCategory.categoryLevel) || categoryLevel;
                dispatch(addCategory({...category, userCategory:{...newUserCategory, categoryLevel:categoryLevel}}));
                resolve(userCategory);
            },
            function(error){ 
                //Server update failed, revert to old state
                dispatch(addCategory(category));
                console.error(error);
                reject(error); 
            });
    });
}




// WEBPACK FOOTER //
// ./src/actions/categories.js